import styled from 'styled-components/macro';

export const OuterWrapper = styled.div``;
